import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e44b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-color-secondary" }, "NEEi,act hours · green = valid", -1))
const _hoisted_3 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No hourly validity data for this period.", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "heatmap-wrap"
}
const _hoisted_7 = { class: "heatmap-hours" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "day-label" }, null, -1))
const _hoisted_9 = { class: "day-label" }
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend mt-2 text-sm text-color-secondary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cell valid legend-swatch" }),
  /*#__PURE__*/_createTextVNode(" valid "),
  /*#__PURE__*/_createElementVNode("span", { class: "cell invalid legend-swatch ml-2" }),
  /*#__PURE__*/_createTextVNode(" invalid "),
  /*#__PURE__*/_createElementVNode("span", { class: "cell missing legend-swatch ml-2" }),
  /*#__PURE__*/_createTextVNode(" missing ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Data validity heatmap" }),
      _hoisted_2
    ]),
    (!_ctx.cells.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (h) => {
              return (_openBlock(), _createElementBlock("span", {
                key: h,
                class: "hour-label"
              }, _toDisplayString(h), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
            return (_openBlock(), _createElementBlock("div", {
              key: day,
              class: "heatmap-row"
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(day.slice(5)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (h) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: day + '-' + h,
                  class: _normalizeClass(["cell", _ctx.cellClass(day, h)]),
                  title: _ctx.tooltip(day, h)
                }, null, 10, _hoisted_10))
              }), 128))
            ]))
          }), 128)),
          _hoisted_11
        ]))
  ]))
}